import styled from "styled-components";

export const Content = styled.div`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  width: 609px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 25px 50px;
`;

export const Strong = styled.strong`
  font-weight: bold;
  margin-right: 5px;
`;

export const Link = styled.a`
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export const TypeLinkContainer = styled.form`
  margin-top: 15px;
`;

export const ActionsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  > button:first-child {
    margin-right: 10px;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
  justify-content: flex-end;
`;
